import Badge from 'components/badge/badge.module';
import { ENGT_ID, LAUNCHER_IMG_ERROR_FALLBACK } from 'consts/consts';
import { BADGE_TYPE, SCREEN_TYPE } from 'consts/enum';
import { addClass, animation, focusElement, preventScaleOrZoom, removeClass, setCustomTagHTML } from 'helpers/helpers';
import { socketInit } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import { appendInitTimeStamp, appendTimeStamp, resetUnreadMessage } from 'js/conversation';

import { launcherIcon } from './launcherIcon.model';
import { LauncherIconTemplate } from './launcherIcon.template';

export class LauncherIcon {
	constructor(props) {
		this.initData();
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData() {
		this.data = launcherIcon;
		this.setter({
			url: ENGT_CHAT.get('config.icon_url'),
			calloutMessage: ENGT_CHAT.get('config.popupMessage'),
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-launch-icon-box';
		wrapper.innerHTML = LauncherIconTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const notificationBadge = new Badge({
			id: ENGT_ID.UNREAD_NOTIFICATION_BADGE,
			type: BADGE_TYPE.SMALL,
			count: 0,
		}).render();

		setCustomTagHTML(this.html.querySelector('notification-badge'), notificationBadge);
	}

	initEventHandlers() {
		this.html.querySelector('#engtLauncherIcon').addEventListener('click', () => {
			ENGT_CHAT.get('onLauncherClick')();
		});
		this.html.querySelector('#engtCalloutText').addEventListener('click', () => {
			ENGT_CHAT.get('onLauncherClick')();
		});
		this.html.querySelector('#engtLauncherIcon').addEventListener('keydown', (e) => {
			ENGT_CHAT.get('onEnterPress')(ENGT_CHAT.get('onLauncherClick'));
		});
		this.html.querySelector('#engtLauncherIcon').addEventListener('error', function (e) {
			this.onerror = null;
			this.src = LAUNCHER_IMG_ERROR_FALLBACK;
		});
		this.html.querySelector('.engt-closed-callout-btn').addEventListener('click', () => {
			if (ENGT_CHAT.get('config.trigger_configurations')?.length) {
				const triggerWrapper = document.getElementById('engt-triggers-wrapper');
				const isTriggersWrapperShown = triggerWrapper?.style?.display === 'block';
				if (isTriggersWrapperShown) {
					removeClass(triggerWrapper, 'engt-triggers-callout-animation-up');
					addClass(triggerWrapper, 'engt-triggers-callout-animation-down');
				}
			}
			ENGT_CHAT.get('hideClosedCallout')();
		});

		const openPopup = () => {
			const popup = document.getElementById('engt-popup');
			removeClass(popup, 'engt-popup-hidden');
			removeClass(popup, 'engt-popup-hidden-size');
			addClass(document.getElementById('engtWrapper'), 'engt-wrapper-open');
			if (ENGT_CHAT.get('getCurrentScreen')() === SCREEN_TYPE.CHAT) {
				addClass(popup, 'engt-chat-screen-open');
				animation.messagesIn();
			} else {
				addClass(popup, 'engt-launch-screen-open');
				animation.launchScreenIn();
			}
			focusElement(popup);
		};

		const hideLauncherBtn = () => {
			const icon = document.getElementById('engtLauncherIcon');
			hideClosedCallout();
			addClass(icon, 'engt-launcher-icon-hidden');
			removeClass(icon, 'engt-launcher-icon-animate');
		};

		const hideClosedCallout = () => {
			const closedCallout = document.getElementById('engtClosedCallout');
			addClass(closedCallout, 'engt-closed-callout-close-animation');
			setTimeout(() => {
				addClass(closedCallout, 'engt-closed-callout-hidden');
				removeClass(closedCallout, 'engt-closed-callout-close-animation');
			}, 1000);
		};

		const hideMinimizedCallout = () => {
			removeClass(document.getElementById('engt-popup'), 'engt-popup-minimized');
		};

		const removeNotificationCount = () => {
			if (ENGT_CHAT.get('getCurrentScreen')() === SCREEN_TYPE.CHAT) {
				resetUnreadMessage();
			}
		};

		const addInitTimeStamp = () => {
			const container = document.querySelector('#engtChatContent');
			if (container && !container.hasChildNodes()) {
				appendTimeStamp({ firstStamp: true });
			}
		};

		ENGT_CHAT.set('hideClosedCallout', hideClosedCallout);

		ENGT_CHAT.set('hideMinimizedCallout', hideMinimizedCallout);

		ENGT_CHAT.set('hideLauncherBtn', hideLauncherBtn);

		ENGT_CHAT.set('openPopup', openPopup);

		ENGT_CHAT.set('onLauncherClick', (isWelcomeMsgEmit = true) => {
			const icon = document.querySelector('#engtLauncherIcon');
			if (ENGT_CHAT.get('config')?.engagement_triggers_config?.enabled) {
				const triggerWrapper = document.getElementById('engt-triggers-wrapper');
				const isTriggersWrapperShown = triggerWrapper?.style?.display === 'block';
				if (isTriggersWrapperShown) {
					triggerWrapper.style.display = 'none';
					removeClass(triggerWrapper, 'engt-triggers-callout-animation-up');
					removeClass(triggerWrapper, 'engt-triggers-callout-animation-down');
				}
			}
			if (ENGT_CHAT.get('startConvoAdded')) {
				const dataInteractiveField = document?.querySelectorAll('[data-interactive-field]:not([disabled])');
				if (dataInteractiveField?.length > 0) {
					dataInteractiveField?.forEach((ele) => {
						if (
							ele?.classList?.contains('engt-ratings') ||
							ele?.classList?.contains('engt-feedback-thumbs')
						) {
							ele.setAttribute('data-rating-disabled', 'true');
						} else {
							ele.setAttribute('disabled', true);
						}
					});
				}
			}
			icon.setAttribute('tabindex', -1);
			openPopup();
			hideLauncherBtn();
			socketInit(isWelcomeMsgEmit);
			appendInitTimeStamp();
			ENGT_CHAT.set('config.isChatOpened', true);
			removeNotificationCount();
			preventScaleOrZoom();
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
